import React from 'react';
import { Container } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';

import Loading from '../containers/Loading';
import connectWithMGPStore from '../reducers/connectWithMGPStore';
import AppContextAPI from './AppContextAPI';
import Router from './Router';
import { UserContextCreator } from '../actions/ContextCreators';

const LoadingWrapper = () => (
    <Container maxWidth="xl">
        <Loading />
    </Container>
);

function App({ indexState, applicationConfig }) {
    const [state, dispatch] = AppContextAPI(indexState);
    console.log('STATE', state);
    return (
        <div className="mgpWrapper">
            {state && !state.isLoading ? (
                    <ThemeProvider theme={createTheme}>
                        <UserContextCreator.Provider value={{ state, dispatch }}>
                            <Router applicationConfig={applicationConfig} />
                        </UserContextCreator.Provider>
                    </ThemeProvider>
                ) : (
                    <LoadingWrapper />
                )}
        </div>
    );
}

export default connectWithMGPStore(App);
